
(function () {
  'use strict';

  if (window.__pcvCardInit) return;
  window.__pcvCardInit = true;

  var CACHE_VERSION = 'pcv-card-v2';
  var CACHE_TTL = 24 * 60 * 60 * 1000;
  var MAX_PAGES = 20;
  var MAX_CONCURRENT = 3;

  var activeRequests = 0;
  var queue = [];
  var inFlight = Object.create(null);

  var rootPath =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root) || '/';

  function cacheKey(title) {
    return CACHE_VERSION + ':' + String(title).trim().toLowerCase();
  }

  function readCache(title) {
    try {
      var cached = JSON.parse(
        localStorage.getItem(cacheKey(title)) || 'null'
      );

      if (
        cached &&
        Date.now() - cached.savedAt < CACHE_TTL &&
        Array.isArray(cached.products)
      ) {
        return cached.products;
      }
    } catch (error) {
      // Ignore unavailable or invalid local storage.
    }

    return null;
  }

  function writeCache(title, products) {
    try {
      localStorage.setItem(
        cacheKey(title),
        JSON.stringify({
          savedAt: Date.now(),
          products: products
        })
      );
    } catch (error) {
      // Swatches still work when local storage is unavailable.
    }
  }

  function normalizeProduct(item) {
    if (!item || item.id == null || !item.title || !item.handle) {
      return null;
    }

    return {
      id: String(item.id),
      title: String(item.title),
      handle: String(item.handle),
      url: item.url || rootPath + 'products/' + item.handle,
      image: item.image || '',
      color_name: item.color_name || '',
      color: item.color || '',
      color_code: item.color_code || ''
    };
  }

  function fetchPage(title, page) {
    var url =
      rootPath +
      'search?view=colour-variants&q=' +
      encodeURIComponent(title) +
      '&type=product&page=' +
      page;

    return fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Colour search failed: ' + response.status);
      }

      return response.json();
    });
  }

  function fetchProducts(title) {
    if (inFlight[title]) {
      return inFlight[title];
    }

    inFlight[title] = fetchPage(title, 1)
      .then(function (firstPage) {
        var pageCount = Math.max(
          1,
          Math.min(parseInt(firstPage.pages, 10) || 1, MAX_PAGES)
        );

        var products = Array.isArray(firstPage.products)
          ? firstPage.products.slice()
          : [];

        var nextPage = 2;

        function fetchNextBatch() {
          if (nextPage > pageCount) {
            return Promise.resolve(products);
          }

          var pageNumbers = [];

          for (
            var i = 0;
            i < 4 && nextPage <= pageCount;
            i++, nextPage++
          ) {
            pageNumbers.push(nextPage);
          }

          return Promise.all(
            pageNumbers.map(function (pageNumber) {
              return fetchPage(title, pageNumber);
            })
          ).then(function (results) {
            results.forEach(function (result) {
              if (Array.isArray(result.products)) {
                products = products.concat(result.products);
              }
            });

            return fetchNextBatch();
          });
        }

        return fetchNextBatch();
      })
      .then(function (items) {
        var seen = Object.create(null);

        var matches = items
          .map(normalizeProduct)
          .filter(function (product) {
            if (!product || product.title !== title) {
              return false;
            }

            if (seen[product.id]) {
              return false;
            }

            seen[product.id] = true;
            return true;
          });

        writeCache(title, matches);

        return matches;
      })
      .finally(function () {
        delete inFlight[title];
      });

    return inFlight[title];
  }

  function enqueue(title) {
    return new Promise(function (resolve, reject) {
      queue.push({
        title: title,
        resolve: resolve,
        reject: reject
      });

      processQueue();
    });
  }

  function processQueue() {
    while (activeRequests < MAX_CONCURRENT && queue.length) {
      (function (job) {
        activeRequests++;

        fetchProducts(job.title)
          .then(job.resolve, job.reject)
          .finally(function () {
            activeRequests--;
            processQueue();
          });
      })(queue.shift());
    }
  }

  function getCurrentProduct(root) {
    return {
      id: String(root.dataset.productId || ''),
      title: root.dataset.productTitle || '',
      handle: root.dataset.productHandle || '',
      url: root.dataset.productUrl || '#',
      image: root.dataset.currentImage || '',
      color_name: root.dataset.currentColorName || '',
      color: root.dataset.currentColor || '',
      color_code: root.dataset.currentColorCode ||
        root.dataset.currentColor || ''
    };
  }

  function isSafeCssColor(value) {
    return /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\)|hsla?\([\d\s.,%]+\)|[a-z]+)$/i
      .test(String(value || '').trim());
  }

  function createSwatch(product, currentId) {
    var link = document.createElement('a');

    link.className = 'product-colour-variants__swatch';
    link.href = product.url;
    link.dataset.productId = product.id;

    var colorName = product.color_name || product.title;

    link.title = colorName;
    link.setAttribute('aria-label', colorName);
    link.setAttribute('aria-describedby', '');

    if (product.id === currentId) {
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'true');
    }

    var color = product.color_code || product.color;

    if (color && isSafeCssColor(color)) {
      link.style.setProperty('--pcv-swatch-color', color);
      link.classList.add('product-colour-variants__swatch--color');
    } else if (product.image) {
      link.classList.add('product-colour-variants__swatch--image');

      var safeImageUrl = String(product.image).replace(/["\\]/g, '');

      link.style.backgroundImage = 'url("' + safeImageUrl + '")';
    } else {
      link.classList.add('product-colour-variants__swatch--empty');
    }

    /*
     * Mobile behaviour:
     * First tap opens the tooltip.
     * Second tap follows the product link.
     */
    link.addEventListener('click', function (event) {
      if (!window.matchMedia('(hover: none)').matches) {
        return;
      }

      if (!link.classList.contains('pcv-tooltip-open')) {
        event.preventDefault();

        var holder = link.closest('[data-pcv-swatches]');

        if (holder) {
          holder.querySelectorAll('.pcv-tooltip-open').forEach(
            function (other) {
              other.classList.remove('pcv-tooltip-open');
            }
          );
        }

        link.classList.add('pcv-tooltip-open');
      } else {
        link.classList.remove('pcv-tooltip-open');
      }
    });

    return link;
  }

  function render(root, products) {
    var current = getCurrentProduct(root);
    var holder = root.querySelector('[data-pcv-swatches]');
    var loader = root.querySelector('[data-pcv-loader]');

    if (!holder) return;

    var seen = Object.create(null);

    products = products.filter(function (product) {
      if (!product || product.title !== current.title) {
        return false;
      }

      if (seen[product.id]) {
        return false;
      }

      seen[product.id] = true;
      return true;
    });

    /*
     * Always include the current product even when Shopify Search
     * does not return it.
     */
    if (current.id && !seen[current.id]) {
      var currentEntry = normalizeProduct(current);

      if (currentEntry) {
        products.unshift(currentEntry);
      }
    }

    var maxProducts = Math.max(
      1,
      parseInt(root.dataset.maxProducts || '4', 10) || 4
    );

    var shown = products.slice(0, maxProducts);

    holder.replaceChildren();

    shown.forEach(function (product) {
      holder.appendChild(
        createSwatch(product, current.id)
      );
    });

    holder.hidden = shown.length === 0;

    if (loader) {
      loader.hidden = true;
    }

    root.classList.toggle('has-swatches', shown.length > 0);
  }

  function initCard(root) {
    if (root.dataset.pcvInitialized === 'true') return;

    root.dataset.pcvInitialized = 'true';

    var title = root.dataset.productTitle;

    if (!title) return;

    var cached = readCache(title);

    if (cached) {
      render(root, cached);
      return;
    }

    enqueue(title)
      .then(function (products) {
        render(root, products);
      })
      .catch(function (error) {
        console.warn(
          '[Product colour swatches] Could not load swatches.',
          error
        );

        var loader = root.querySelector('[data-pcv-loader]');

        if (loader) {
          loader.hidden = true;
        }
      });
  }

  function scanNode(node) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches('[data-pcv-card]')) {
      initCard(node);
    }

    node.querySelectorAll('[data-pcv-card]').forEach(initCard);
  }

  function start() {
    var cards = document.querySelectorAll('[data-pcv-card]');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              initCard(entry.target);
            }
          });
        },
        {
          rootMargin: '200px 0px'
        }
      );

      cards.forEach(function (card) {
        observer.observe(card);
      });
    } else {
      cards.forEach(initCard);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }

  /*
   * Supports collection filters, AJAX-loaded product cards
   * and other dynamically inserted cards.
   */
  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          scanNode(node);
        });
      });
    });

    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /*
   * Close an open mobile tooltip when the customer taps elsewhere.
   */
  document.addEventListener('click', function (event) {
    if (
      event.target.closest &&
      event.target.closest('.product-colour-variants__swatch')
    ) {
      return;
    }

    document.querySelectorAll('.pcv-tooltip-open').forEach(
      function (swatch) {
        swatch.classList.remove('pcv-tooltip-open');
      }
    );
  });
})();
